import React from 'react'
import styles from '../Proj1Folder/Proj1.module.css'
import ifcg1 from '../../Images/ifcg1.jpg'
import ifcg2 from '../../Images/ifcg2.jpg'
import ifcg3 from '../../Images/ifcg3.jpg'
import ifcg4 from '../../Images/ifcg4.jpg'
import ifcg5 from '../../Images/ifcg5.jpg'
import ifcg8 from '../../Images/botato1.jpeg'
import ifcg9 from '../../Images/botato2.jpeg'
import ifcg10 from '../../Images/botato3.jpeg'
import ifcg12 from '../../Images/botato5.jpeg'
import ifcg13 from '../../Images/botato6.jpeg'
import ifcg14 from '../../Images/botato7.jpeg'
import ifcg15 from '../../Images/botato8.jpeg'
import ifcg16 from '../../Images/botato9.jpeg'
import ifcg17 from '../../Images/botatos100.jpeg'


export default function IFCG() {
  return (
    <div className="container my-5 py-5 ">
    <div className="row  align-items-center">
      <div className="col-md-6">
          <h3 className={`${styles.color} my-3`}> International Food Consumable Goods (IFCG)  ​</h3>
          <p> Project description: admin and production hall </p>
          <p>Type of contract: Design and supervision </p>
          <p> Area:  13000 m2 </p>
          <p>Owner Name : IFCG </p>
          <p>Type of works : architectural , civil and electromechanical design </p>
      </div>
      <div className="col-md-6">
          <img src={ifcg1} alt="achegy" className='img-fluid'/>
      </div>   
    </div>

    <div className="row my-5 pb-5">

        <div className="col-md-4 my-1 text-center">
         <img src={ifcg17} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
               <div className="col-md-4 my-1 text-center">
         <img src={ifcg8} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
            <div className="col-md-4 my-1 text-center">
         <img src={ifcg12} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>

      <div className="col-md-4 my-1 text-center">
         <img src={ifcg13} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
   

      <div className="col-md-4 my-1 text-center">
         <img src={ifcg14} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
    <div className="col-md-4 my-1 text-center">
         <img src={ifcg2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
      <div className="col-md-4 my-1 text-center">
         <img src={ifcg3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
      <div className="col-md-4 my-1 text-center">
         <img src={ifcg4} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>

      
   

      <div className="col-md-4 my-1 text-center">
         <img src={ifcg9} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>

      <div className="col-md-4 my-1 text-center">
         <img src={ifcg10} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>

  

    

      <div className="col-md-4 my-1 text-center">
         <img src={ifcg15} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>

     <div className="col-md-4 my-1 text-center">
         <img src={ifcg5} alt="achegy" className={`${styles.imgSizeProj}`}/> 
      </div>
   
     
   


 
    </div>
  </div>
  )
}
